import PropTypes from 'prop-types';
import { breakpoints, Inline, vars } from '@etg/wings';
import { StackedIcon } from '@eti/components';
import { css } from '@eti/styles';

const headingStyles = css`
  color: #fff;
  font-size: 1.125rem;
  line-height: 1.3;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 50%);

  @media (min-width: ${breakpoints._768}) {
    font-size: 1.25rem;
  }

  @media (min-width: ${breakpoints._970}) {
    text-shadow: none;
  }
`;

const icons = [
  { color: vars.colors.signal.positive.light, id: 'circle', size: '24px' },
  { color: '#fff', id: 'check', size: '16px' },
];

const checkIconStyles = css`
  align-self: flex-start;
  flex-shrink: 0;
  height: 24px;
  width: 24px;
`;

const Title = ({ children }) => (
  <Inline align="center" noWrap spacing={8}>
    <StackedIcon className={checkIconStyles} icons={icons} />
    <h2 className={headingStyles} data-testid="order-bookingReferences-heading">
      {children}
    </h2>
  </Inline>
);

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
